import React from 'react';
import MaterialMovementsProvider from "./material-movements.context.jsx";
import MaterialMovements from "./material-movements.jsx";

const MaterialMovementsInit = () => {
    return (
        <MaterialMovementsProvider>
            <MaterialMovements />
        </MaterialMovementsProvider>
    );
};

export default MaterialMovementsInit;